// extracted by mini-css-extract-plugin
module.exports = {"container":"ue-z","heading":"ve-z","links":"we-z","linkBtn":"xe-z","disabled":"ye-z","linkUppercaseBold":"ze-z","copy":"Ae-z","subCopy":"Be-z"};